import * as React from 'react';
import {Image} from 'react-native';

import convertImageSource from '../../../helpers/convertImageSource';

import coinUri from '../../../../assets/images/coin.png';

interface Props {
  width?: number;
  height?: number;
}

const Coin: React.FC<Props> = props => {
  const {width, height} = props;
  return (
    <Image
      source={convertImageSource(coinUri)}
      style={{width: width || 18, height: height || 18}}
    />
  );
};

export default React.memo(Coin);
